import React from 'react';
import { Link, LinkProps } from '@mui/material';

const ZEUS_BASE_URL = import.meta.env.VITE_ZEUS_BASE_URL;

interface ZeusLinkProps extends Omit<LinkProps, 'href'> {
  path: string;
}

export default function ZeusLink({ path, children, ...linkProps }: ZeusLinkProps) {
  return (
    <Link href={`${ZEUS_BASE_URL}${path}`} target="_blank" rel="noreferrer noopener" {...linkProps}>
      {children}
    </Link>
  );
}
